import React from 'react';
import PropTypes from 'prop-types';

const Notification = ({ type, title, message, onClose }) => {
  return (
    <div className={`fixed top-20 right-4 w-96 bg-white rounded-lg shadow-lg border-l-4 ${
      type === 'success' ? 'border-green-600' : 'border-red-600'
    }`}>
      <div className="p-4 flex items-start">
        <div className={`flex-shrink-0 ${type === 'success' ? 'bg-green-50' : 'bg-red-50'} p-2 rounded-full`}>
          {type === 'success' ? (
            <img src="/icons/sucess-notification.svg" alt="success" className="w-5 h-5" />
          ) : (
            <img src="/icons/error-notification.svg" alt="error" className="w-5 h-5" />
          )}
        </div>
        <div className="ml-3 w-full">
          <h3 className="text-sm font-medium text-gray-900">{title}</h3>
          <div className="mt-1 text-sm text-gray-500">{message}</div>
        </div>
        <button
          onClick={onClose}
          className="ml-4 flex-shrink-0 text-gray-400 hover:text-gray-500 focus:outline-none"
        >
          <span className="sr-only">Close</span>
          <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  );
};

Notification.propTypes = {
  type: PropTypes.oneOf(['success', 'error']).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Notification;